import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { changelayout, changeMode } from './store/layouts/layout-action';
import { RootReducerState } from './store';
import { Store } from '@ngrx/store';
import { LAYOUT_TYPES } from './store/layouts/layout';
import { LayoutState } from './store/layouts/layout-reducers';

import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { Languages } from '@app/core/services/languages.enum';
import { PrimeNGConfig } from "@primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { primengTranslations } from "@app/primeng-translations";
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';

import { deLocale } from 'ngx-bootstrap/locale';
import { setTheme } from 'ngx-bootstrap/utils';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  layOutTypes = LAYOUT_TYPES

  layOutData!: LayoutState;

  constructor(
    protected store: Store<RootReducerState>,
    protected primengConfig: PrimeNGConfig,
    protected translateService: TranslateService,
    protected localeService: BsLocaleService
  ) {
    setTheme('bs5');

    this.store.select('layout').subscribe((data) => {
      this.layOutData = data;
    })

    this.translateService.onLangChange.subscribe(
      (lang) => {
        this.primengConfig.setTranslation(primengTranslations[lang.lang]);
        this.localeService.use(lang.lang);
      }
    )

    this.localeService.use(this.translateService.currentLang);
  }

  ngOnInit(): void {
    this.changeMode(this.layOutData.LAYOUT_MODE);
    this.changeLayout(this.layOutData.LAYOUT);

    defineLocale('de', deLocale);

    registerLocaleData(localeEn, Languages.EN);
    registerLocaleData(localeDe, Languages.DE);
  }

  changeMode(mode: string) {
    this.store.dispatch(changeMode({mode}));
  }

  changeLayout(layout: string) {
    this.store.dispatch(changelayout({layout}));
  }
}
